import axios from 'axios'
import { createApp } from 'vue'
import FButton from '~/js/components/button'
import FProductCard from '~/js/components/productCard'
import { numberWithCommas } from '~/js/helpers'
import { getItemsFromIds } from '~/js/helpers/getProducts'
import { getParam } from '~/js/helpers/url-helper'
import { isDesktop } from '~/js/templates/index/helpers'

const ID_PAGES_PRODUCTLIST = 'js-pages-product-list'

document.addEventListener('DOMContentLoaded', async () => {
  const elementPagesProductlist = document.getElementById(ID_PAGES_PRODUCTLIST)
  if (!elementPagesProductlist) return
  const { baseUrl } = elementPagesProductlist.dataset

  const id = getParam('id')

  const getProducts = async (ids) => {
    return await getItemsFromIds(ids)
  }

  let title = ''
  let hasError = false
  let productIds = []
  let products = []
  try {
    const { data } = await axios.get(`${baseUrl}/customers/wishlist`, {
      params: { id },
    })
    title = data.title
    productIds = data.productIds
    products = await getProducts(productIds)
  } catch (error) {
    console.error(error)
    hasError = true
  }

  createApp({
    name: 'TemplatesPageProductlist',
    components: {
      FButton,
      FProductCard,
    },
    data() {
      return {
        hasError,
        isProcessing: false,
        products: products.filter((v) => v),
        size: isDesktop() ? undefined : 'small',
        title,
      }
    },
    computed: {
      totalPrice() {
        const totalPrice = this.products.reduce(
          (total, product) => total + product.price,
          0
        )
        return numberWithCommas(totalPrice)
      },
    },
    methods: {
      async retry() {
        this.isProcessing = true
        try {
          this.products = await getProducts(productIds)
          this.hasError = false
        } catch (e) {
          this.hasError = true
          console.error(e)
        }
        this.isProcessing = false
      },
    },
  }).mount(elementPagesProductlist)
})
